import React from 'react';
import ReactDOM from 'react-dom';
import './i18n'; // Import i18n configuration BEFORE App
import App from './App';
import './styles/index.css';

// Make sure i18n is imported before rendering the App
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);